import {gsap} from "gsap";

var layer1 = promokit.layer({
    el: '#layer-1',
    buttons: '.btn-util1'
});

var layer2 = promokit.layer({
    el: '#layer-2',
    buttons: '.btn-util2'
});

var layer3 = promokit.layer({
    el: '#layer-3',
    buttons: '.btn-util3'
});


// 이미지 뷰어
let urlPath = promokit.store('staticPath');

var viewer1 = promokit.viewer({
    images: [
        {
            src: `${urlPath}/promo/aion/history/2021/210203_update/img/pc/change/item1.jpg`,
            title: '네자칸'
        },
        {
            src: `${urlPath}/promo/aion/history/2021/210203_update/img/pc/change/item2.jpg`,
            title: '네자칸'
        },
        {
            src: `${urlPath}/promo/aion/history/2021/210203_update/img/pc/change/item3.jpg`,
            title: '네자칸'
        }
    ]
});

var viewer2 = promokit.viewer({
    images: [
        {
            src: `${urlPath}/promo/aion/history/2021/210203_update/img/pc/change/item4.jpg`,
            title: '지켈'
        },
        {
            src: `${urlPath}/promo/aion/history/2021/210203_update/img/pc/change/item5.jpg`,
            title: '지켈'
        },
        {
            src: `${urlPath}/promo/aion/history/2021/210203_update/img/pc/change/item6.jpg`,
            title: '지켈'
        }
    ]
});
$('.change__left a').on('click', function() {
    viewer1.open($(this).data('index'))
})

$('.change__right a').on('click', function() {
    viewer2.open($(this).data('index'))
})

/*
$(document).on('click', '.btn-detail2', function(e) {
    viewer1.open(1);
});
$(document).on('click', '.btn-detail3', function(e) {
    viewer1.open(2);
});
$(document).on('click', '.btn-detail4', function(e) {
    viewer2.open(1);
});
$(document).on('click', '.btn-detail6', function(e) {
    viewer2.open(2);
});*/

const intiAni = gsap.timeline({paused:true})
    .addLabel('start')
    .from('.change__bg', 7, {scale:1.5, ease:"Power1.easeOut"},"start")
    .from('.change__title', 0.9, {y:120, autoAlpha:0, ease:"Power1.easeOut"}, "start+=0.5")
    .from('.change__txt', 0.9, {y:120, autoAlpha:0, ease:"Power1.easeOut"}, "start+=0.7")
    .from('.change__left', 0.9, {x:-120, autoAlpha:0, ease:"Power1.easeOut"}, "start+=1.3")
    .from('.change__right', 0.9, {x:120, autoAlpha:0, ease:"Power1.easeOut"}, "start+=1.3")
    .staggerFrom('.change__util li', 0.6, {y:120, opacity:0,ease: "Power1.easeOut",}, 0.1, 'start+=1.5');


export default {
    id: '#change',
    name: '신규 궁극 변신-',
    enterStart() {
        intiAni.seek(0);
        intiAni.play();
    },
    enterEnd(){

    },
    leaveStart() {

    },
    leaveEnd(){

    }
};



// WEBPACK FOOTER //
// ./src/js/page/change.js